import React from 'react';
import './PropertyDataPanel.css';

const PropertyDataPanel = ({ propertyData, onClose, blurred, onUnlock }) => {
  if (!propertyData) return null;

  const parcelNumber = propertyData.ParcelNumber || propertyData.parcelNumber || '—';
  const municipality  = propertyData.KatastrskaObcina ?? propertyData.katastrskaObcina ?? '—';
  const propertyId    = propertyData.PropertyId || propertyData.propertyId || null;

  const owners = Array.isArray(propertyData.Owners)
    ? propertyData.Owners
    : Array.isArray(propertyData.owners)
      ? propertyData.owners
      : [];

  return (
    <div className="property-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="property-panel">

        <div className="property-panel-content">

          {/* Header */}
          <div className="property-header">
            <div className="property-header-title">
              <div>
                <h3>Podatki o lastništvu</h3>
                <p>Rezultat poizvedbe</p>
              </div>
            </div>
            <button className="property-close-btn" onClick={onClose} title="Zapri">✕</button>
          </div>

          {/* Meta */}
          <div className="property-meta">
            <div className="property-meta-item">
              <span className="property-meta-label">Katastrska občina (KO)</span>
              <span className="property-meta-value">{municipality}</span>
            </div>
            <div className="property-meta-item">
              <span className="property-meta-label">Številka parcele</span>
              <span className="property-meta-value">{parcelNumber}</span>
            </div>
            {propertyId && (
              <div className="property-meta-item">
                <span className="property-meta-label">ID nepremičnine</span>
                <span className="property-meta-value">{propertyId}</span>
              </div>
            )}
          </div>

          {/* Owners */}
          <div className="property-owners-section">
            <div className="property-owners-title">
              Lastniki
              <span className="owner-count-badge">{owners.length}</span>
            </div>

            {owners.length === 0 ? (
              <p style={{ color: '#6c757d', fontSize: '0.9rem' }}>Podatki o lastnikih niso bili najdeni.</p>
            ) : (
              owners.map((owner, idx) => {
                const isLegal  = owner.IsLegalEntity || owner.isLegalEntity || false;
                const share    = owner.Share         || owner.share         || '—';
                const address  = owner.Address       || owner.address       || '—';

                // Legal entity fields
                const firmaNaziv      = owner.FirmaNaziv      || owner.firmaNaziv      || '—';
                const maticnaStevilka = owner.MaticnaStevilka || owner.maticnaStevilka || '—';

                // Natural person fields
                const name = owner.PersonalName || owner.personalName || '—';
                const emso = owner.Emso         || owner.emso         || '—';

                return (
                  <div key={idx} className={`owner-card ${isLegal ? 'owner-card--legal' : ''}`}>
                    <div className="owner-card-header">
                      <div className="owner-name">{isLegal ? firmaNaziv : name}</div>
                      <span className={`owner-type-badge ${isLegal ? 'owner-type-badge--legal' : 'owner-type-badge--natural'}`}>
                        {isLegal ? 'Pravna oseba' : 'Fizična oseba'}
                      </span>
                    </div>
                    <div className="owner-details-grid">
                      <div className="owner-detail">
                        <span className="owner-detail-label">Delež</span>
                        <span className="owner-detail-value share">{share}</span>
                      </div>
                      {isLegal ? (
                        <div className="owner-detail">
                          <span className="owner-detail-label">Matična številka</span>
                          <span className="owner-detail-value">{maticnaStevilka}</span>
                        </div>
                      ) : (
                        <div className="owner-detail">
                          <span className="owner-detail-label">EMŠO</span>
                          <span className="owner-detail-value">{emso}</span>
                        </div>
                      )}
                      <div className="owner-detail" style={{ gridColumn: '1 / -1' }}>
                        <span className="owner-detail-label">Naslov</span>
                        <span className="owner-detail-value">{address}</span>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>

          {/* Footer */}
          <div className="property-footer">
            {blurred && (
              <button className="btn-unlock-property" onClick={onUnlock}>Odklenite omejitve iskanja</button>
            )}
            <button className="btn-close-property" onClick={onClose}>Zapri</button>
          </div>

        </div>{/* /property-panel-content */}

      </div>
    </div>
  );
};

export default PropertyDataPanel;
